module.exports = __webpack_public_path__ + "img/monitorbox17.8efa1db4.jpg";